import React, { createContext, useContext, useState } from 'react';
import { IVideoPlayer } from './index';

export type StackVideoPlayerContext = {
  players?: Map<string, IVideoPlayer>;
  addPlayer?: ({ id, player }: { id: string; player: IVideoPlayer }) => void;
};

export const StackVideoPlayerContext = createContext<StackVideoPlayerContext>({});

export type StackVideoPlayerContextProviderProps = {
  children: React.ReactNode;
};

/* Global context for HTML5 videos and YouTube iframes.
   Surfaces a 'player' for each video that allows other components to control the playback */
export const StackVideoPlayerContextProvider: React.FC<StackVideoPlayerContextProviderProps> = ({ children }) => {
  const [players, setPlayers] = useState<Map<string, IVideoPlayer>>(new Map());

  const addPlayer = ({ id, player }: { id: string; player: IVideoPlayer }) =>
    setPlayers(prevPlayers => prevPlayers.set(id, player));

  return <StackVideoPlayerContext.Provider value={{ players, addPlayer }}>{children}</StackVideoPlayerContext.Provider>;
};

export const useStackVideoPlayerContext = (): StackVideoPlayerContext => {
  return useContext(StackVideoPlayerContext) ?? {};
};
